export default "__VITE_ASSET__kYeEKULB__"